import { createContext, FC, useCallback, useContext, useMemo } from 'react';
import { REMOVE_POSITIONS } from 'constants/endpoints';
import { METHOD_DELETE } from 'requests';
import { useAPIActions } from 'store/reducers/api/apiSlice';
import { ApiRequestConfigType } from 'requests/index.types';
import { handleGenericErrorMessage } from 'utils/handleGenericErrorMessage';
import { RemovePositionDialogProps } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionDialog/RemovePositionDialog.types';

interface RemovePositionDialogForm {
  handleRemovePosition: () => void;
  communityName?: string;
}

const API_DELETE_PositionAllocation = (
  community_id: string,
  position_id: number,
): ApiRequestConfigType => ({
  __typename: 'LegacyAPI',
  url: REMOVE_POSITIONS(community_id, position_id),
  method: METHOD_DELETE,
});

export const RemovePositionDialogFormContext = createContext({} as RemovePositionDialogForm);

export const RemovePositionDialogFormProvider: FC<RemovePositionDialogProps> = ({
  children,
  communityId,
  positionId,
  onSuccess,
  communityName,
}) => {
  const { apiRequest } = useAPIActions();

  const handleRemovePosition = useCallback(
    async () =>
      await apiRequest(API_DELETE_PositionAllocation(communityId, positionId), {
        onSuccess,
        onError: handleGenericErrorMessage,
      }),
    [apiRequest, onSuccess, communityId, positionId],
  );

  const contextValue = useMemo(
    () => ({
      handleRemovePosition,
      communityName,
    }),
    [handleRemovePosition, communityName],
  );

  return (
    <RemovePositionDialogFormContext.Provider value={contextValue}>
      {children}
    </RemovePositionDialogFormContext.Provider>
  );
};

export const useRemovePositionDialogFormContext = () => useContext(RemovePositionDialogFormContext);
